exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-0ad256fd] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n", ""]);

// exports
